import { asDisplayCur } from "@/helpers/inputHelpers";
import type { ExistingMortgage } from "@loanlink-nl/model-app";

export function titleForMortgage(
	mortgage: ExistingMortgage,
	lenderLabel?: string,
) {
	const parts: string[] = [];

	if (lenderLabel) {
		parts.push(lenderLabel);
	}

	// Ignoring 0 is desired
	if (mortgage.amountCurrent) {
		parts.push(asDisplayCur(mortgage.amountCurrent));
	}

	if (mortgage.lenderMortgageId) {
		parts.push(mortgage.lenderMortgageId);
	}

	return parts.join(" - ");
}
